__turbopack_context__.v({
  "active": "L4I_3G_active",
  "addPanelBtn": "L4I_3G_addPanelBtn",
  "chapterAddBtn": "L4I_3G_chapterAddBtn",
  "chapterItem": "L4I_3G_chapterItem",
  "chapterItemActions": "L4I_3G_chapterItemActions",
  "chapterItemActive": "L4I_3G_chapterItemActive",
  "chapterItemCount": "L4I_3G_chapterItemCount",
  "chapterItemInfo": "L4I_3G_chapterItemInfo",
  "chapterItemInput": "L4I_3G_chapterItemInput",
  "chapterItemName": "L4I_3G_chapterItemName",
  "chapterItemNameRow": "L4I_3G_chapterItemNameRow",
  "chapterItemNumber": "L4I_3G_chapterItemNumber",
  "chapterSidebar": "L4I_3G_chapterSidebar",
  "characterAvatar": "L4I_3G_characterAvatar",
  "characterCard": "L4I_3G_characterCard",
  "characterDelete": "L4I_3G_characterDelete",
  "characterInfo": "L4I_3G_characterInfo",
  "characterName": "L4I_3G_characterName",
  "characterStatus": "L4I_3G_characterStatus",
  "dangerBtn": "L4I_3G_dangerBtn",
  "detailActions": "L4I_3G_detailActions",
  "detailCharacterPill": "L4I_3G_detailCharacterPill",
  "detailSectionTitle": "L4I_3G_detailSectionTitle",
  "detailStat": "L4I_3G_detailStat",
  "detailStatLabel": "L4I_3G_detailStatLabel",
  "detailStatValue": "L4I_3G_detailStatValue",
  "detailStatusBadge": "L4I_3G_detailStatusBadge",
  "detailStatusDot": "L4I_3G_detailStatusDot",
  "drawer": "L4I_3G_drawer",
  "drawerBackdrop": "L4I_3G_drawerBackdrop",
  "drawerContent": "L4I_3G_drawerContent",
  "drawerHeader": "L4I_3G_drawerHeader",
  "drawerImageContainer": "L4I_3G_drawerImageContainer",
  "enhanceImagePreview": "L4I_3G_enhanceImagePreview",
  "enhanceSourceOptions": "L4I_3G_enhanceSourceOptions",
  "enhancedBadge": "L4I_3G_enhancedBadge",
  "failed": "L4I_3G_failed",
  "generating": "L4I_3G_generating",
  "gradientBtn": "L4I_3G_gradientBtn",
  "gradientTopBorder": "L4I_3G_gradientTopBorder",
  "headerActions": "L4I_3G_headerActions",
  "headerCard": "L4I_3G_headerCard",
  "headerContent": "L4I_3G_headerContent",
  "headerImage": "L4I_3G_headerImage",
  "heroBanner": "L4I_3G_heroBanner",
  "heroBannerEdit": "L4I_3G_heroBannerEdit",
  "heroBannerEmpty": "L4I_3G_heroBannerEmpty",
  "heroBannerImg": "L4I_3G_heroBannerImg",
  "heroBannerPlaceholder": "L4I_3G_heroBannerPlaceholder",
  "mobileChapterBtn": "L4I_3G_mobileChapterBtn",
  "noRefs": "L4I_3G_noRefs",
  "panelCard": "L4I_3G_panelCard",
  "panelCharacterPill": "L4I_3G_panelCharacterPill",
  "panelEmpty": "L4I_3G_panelEmpty",
  "panelFailed": "L4I_3G_panelFailed",
  "panelImage": "L4I_3G_panelImage",
  "panelMenu": "L4I_3G_panelMenu",
  "panelModeTab": "L4I_3G_panelModeTab",
  "panelModeTabActive": "L4I_3G_panelModeTabActive",
  "panelModeTabs": "L4I_3G_panelModeTabs",
  "panelNumber": "L4I_3G_panelNumber",
  "panelOverlay": "L4I_3G_panelOverlay",
  "panelPrompt": "L4I_3G_panelPrompt",
  "pending": "L4I_3G_pending",
  "promptBox": "L4I_3G_promptBox",
  "promptBoxEnhanced": "L4I_3G_promptBoxEnhanced",
  "pulse": "L4I_3G_pulse",
  "ready": "L4I_3G_ready",
  "sidebarSection": "L4I_3G_sidebarSection",
  "sidebarTitle": "L4I_3G_sidebarTitle",
  "spin": "L4I_3G_spin",
  "spinner": "L4I_3G_spinner",
  "statDot": "L4I_3G_statDot",
  "statPill": "L4I_3G_statPill",
  "statusDot": "L4I_3G_statusDot",
  "subtleBtn": "L4I_3G_subtleBtn",
  "subtleBtnSm": "L4I_3G_subtleBtnSm",
  "workspaceGrid": "L4I_3G_workspaceGrid",
});
